import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const BullrunRuntimeContext = createContext(undefined);
export const BullrunRuntimeProvider = ({ value, children, }) => _jsx(BullrunRuntimeContext.Provider, { value: value, children: children });
export function useBullrunRuntime() {
    const ctx = useContext(BullrunRuntimeContext);
    if (!ctx) {
        throw new Error("useBullrunRuntime must be used within a BullrunRuntimeProvider");
    }
    return ctx;
}
